import { MovementsTMComponent } from './components/movements-tm/movements-tm.component';
import { ToolImportFormComponent } from './components/tools-import-form/tools-import-form.component';
import { SharingService } from './services/sharing.service';
import { ImageComponent } from './core/image/image.component';
import { ToolTypeFormComponent } from './components/tools-type-form/tools-type-form.component';
import { ParametrosComponent } from './components/parametros/parametros-component';
import { PasswordComponent } from './components/password/password.component';
import { TeamsFormComponent } from './components/teams-form/teams-form.component';
import { TeamsComponent } from './components/teams/teams-component';
import { LockersDetailsComponent } from './components/lockers-details/lockers-details.component';
import { LockersEditComponent } from './components/lockers-edit/lockers-edit.component';
import { CompartmentFormComponent } from './components/compartment-form/compartment-form.component';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { RatingComponent } from './components/users/rating.component';
import { DashboardTMComponent } from './components/dashboard-tm/dashboard-tm.component';
import { DashboardIVComponent } from './components/dashboard-iv/dashboard-iv.component';
import { DashboardIVTMComponent } from './components/dashboard-ivtm/dashboard-ivtm.component';
import { HeaderComponent } from './core/header/header.component';
import { UsersComponent } from './components/users/users.component';
import { ToolsComponent } from './components/tools/tools.component';
import { SitesComponent } from './components/sites/sites-component';
import { LockersComponent } from './components/lockers/lockers.component';
import { CustomMessagesService } from './services/custom-messages.service';
import { InventoryComponent } from './components/inventory/inventory.component';
import { ConumptionComponent } from './components/consumption/consumption.component';
import { ItemsComponent } from './components/items/items.component';
import { ItemsFormComponent } from './components/items-form/items-form.component';
import { ItemsImportFormComponent } from './components/items-import-form/items-import-form.component';
import { CostCentersComponent } from './components/cost-centers/cost-centers.component';
import { CostCentersFormComponent } from './components/cost-centers-form/cost-centers-form.component';
import { CostCentersImportFormComponent } from './components/cost-centers-import-form/cost-centers-import-form.component';
import { EntitiesComponent } from './components/entities/entities.component';
import { EntitiesFormComponent } from './components/entities-form/entities-form.component';
import { MovementsIVComponent } from './components/movements-iv/movements-iv.component';
import { AlertsComponent } from './components/alerts/alerts.component';
import { AlertsFormComponent } from './components/alerts-form/alerts-form.component';
import { AnomalyComponent } from './components/anomaly/anomaly-component';
import { AnomalyFormComponent } from './components/anomaly-form/anomaly-form.component';
import { ExcelModule, GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FileSelectModule } from '@progress/kendo-angular-upload';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { IntlModule } from '@progress/kendo-angular-intl';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { MessageService } from '@progress/kendo-angular-l10n';
import { DialogService, WindowModule } from '@progress/kendo-angular-dialog';
import { DialogModule } from "@progress/kendo-angular-dialog";
import { GaugesModule } from "@progress/kendo-angular-gauges";
import { DatePipe } from '@angular/common';
import { LoadingInterceptor } from './services/loader/loading.interceptor';
import 'hammerjs';
import '@progress/kendo-angular-intl/locales/en/all';
import '@progress/kendo-angular-intl/locales/es/all';
import '@progress/kendo-angular-intl/locales/fr/all';
import '@progress/kendo-angular-intl/locales/pt/all';
import { SiteFormComponent } from './components/sites-form/sites-form.component';
import { MasterComponent } from './components/master/master.component';
import { AuthGuard } from './core/auth/auth.guard';
import { AuthService } from './core/auth/auth.service';
import { TempStateService } from './core/navigation/tempState.service';
import { ToolsTypeComponent } from './components/tools-type/tools-type.component';
import { ToolSubTypeFormComponent } from './components/tools-subtype-form/tools-subtype-form.component';
import { ToolsSubTypeComponent } from './components/tools-subtype/tools-subtype.component';
import { ToolsFormComponent } from './components/tools-form/tools-form.component';
import { UsersFormComponent } from './components/users-form/users-form.component';
import { HttpErrorInterceptor } from './core/http/http-request-error-interceptor';
import { AvariaTypeFormComponent } from './components/tools-type-form/avaria-type-form/avaria-type-form.component';
import { LockersFormComponent } from './components/lockers-form/lockers-form.component';
import { EquipaTypeFormComponent } from './components/teams-type-form/teams-type-form.component';
import { ModulesFormComponent } from './components/modules-form/modules-form.component';
import { UsersImportFormComponent } from './components/users-import-form/users-import-form.component';
import { ChangePasswordComponent } from './components/changepassword/changepassword.component';
import { RecoverPasswordComponent } from './components/recover-password/recover-password.component';
import { MenusModule } from '@progress/kendo-angular-menu';
import localePt from '@angular/common/locales/pt';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ProfileImageComponent } from './components/profileImg/profileImg.component';
import { EquipaItemFormComponent } from './components/teams-item-form/teams-item-form.component';
import { EquipaIVTMFormComponent } from './components/teams-ivtm-form/teams-ivtm-form.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';


const drawerRoutes = [
    {
        path: '',
        component: MasterComponent,
        canActivateChild: [AuthGuard],
        children: [

            { path: '', component: DashboardComponent },
            { path: 'dashboardtm', component: DashboardTMComponent },
            { path: 'dashboardiv', component: DashboardIVComponent },
            { path: 'dashboardivtm', component: DashboardIVTMComponent },
            { path: 'inventory', component: InventoryComponent },
            { path: 'consumption', component: ConumptionComponent },
            { path: 'sites', component: SitesComponent },
            { path: 'lockers', component: LockersComponent },
            { path: 'tools', component: ToolsComponent },
            { path: 'compartmentform', component: CompartmentFormComponent },
            { path: 'parameters', component: ParametrosComponent },
            { path: 'toolstypes', component: ToolsTypeComponent },
            { path: 'toolssubtypes', component: ToolsSubTypeComponent },
            { path: 'teams', component: TeamsComponent },
            { path: 'users', component: UsersComponent },
            { path: 'changepass', component: ChangePasswordComponent },
            { path: 'movementstm', component: MovementsTMComponent },
            { path: 'items', component: ItemsComponent },
            { path: 'costcenters', component: CostCentersComponent },
            { path: 'entities', component: EntitiesComponent },
            { path: 'movementsiv', component: MovementsIVComponent },
            { path: 'anomaly', component: AnomalyComponent },
            { path: 'anomalyform', component: AnomalyFormComponent },
            { path: 'alerts', component: AlertsComponent },
        ]
    },
    { path: 'login', component: LoginComponent },
    { path: 'recoverpass', component: RecoverPasswordComponent },

    { path: 'pass', component: PasswordComponent },
    { path: '**', redirectTo: '/' }
];

registerLocaleData(localePt);
registerLocaleData(localeFr);

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        RatingComponent,
        DashboardComponent,
        DashboardTMComponent,
        DashboardIVComponent,
        DashboardIVTMComponent,
        ConumptionComponent,
        LockersComponent,
        HeaderComponent,
        UsersComponent,
        SitesComponent,
        ToolsFormComponent,
        ModulesFormComponent,
        ToolTypeFormComponent,
        ToolImportFormComponent,
        EquipaTypeFormComponent,
        InventoryComponent,
        SiteFormComponent,
        UsersImportFormComponent,
        LockersDetailsComponent,
        LockersEditComponent,
        CompartmentFormComponent,
        ToolsComponent,
        TeamsComponent,
        TeamsFormComponent,
        UsersFormComponent,
        MasterComponent,
        ParametrosComponent,
        PasswordComponent,
        ToolsTypeComponent,
        ToolSubTypeFormComponent,
        ToolsSubTypeComponent,
        ImageComponent,
        ProfileImageComponent,
        AvariaTypeFormComponent,
        LockersFormComponent,
        ChangePasswordComponent,
        RecoverPasswordComponent,
        MovementsTMComponent,
        ItemsComponent,
        ItemsFormComponent,
        ItemsImportFormComponent,
        CostCentersComponent,
        CostCentersFormComponent,
        CostCentersImportFormComponent,
        EntitiesComponent,
        EntitiesFormComponent,
        MovementsIVComponent,
        AnomalyComponent,
        AnomalyFormComponent,
        AlertsComponent,
        AlertsFormComponent,
        SpinnerComponent,
        EquipaItemFormComponent,
        EquipaIVTMFormComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        GaugesModule,
        ReactiveFormsModule,
        GridModule,
        PDFModule,
        ExcelModule,
        LabelModule,
        LayoutModule,
        SchedulerModule,
        ButtonsModule,
        EditorModule,
        FileSelectModule,
        HttpClientModule,
        ChartsModule,
        IntlModule,
        DialogModule,
        WindowModule,
        DateInputsModule,
        InputsModule,
        DropDownsModule,
        RouterModule.forRoot(drawerRoutes, { useHash: true }),
        NotificationModule,
        MenusModule
    ],
    providers: [
        { provide: MessageService, useClass: CustomMessagesService },
        { provide: DialogService },
        AuthService,
        SharingService,
        AuthGuard,
        TempStateService,
        DatePipe,
        { provide: LOCALE_ID, useValue: 'pt' }
        , {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingInterceptor,
            multi: true
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
